import { Tag, Card, DatePicker, Input, Select, Table, message } from "antd";
import network from "network/network";
import React, { useEffect, useState } from "react";
import localeEN from 'antd/es/date-picker/locale/en_GB';
import localeTR from 'antd/es/date-picker/locale/tr_TR';
import moment from 'moment';
import 'moment/locale/tr';
import 'moment/locale/en-gb';


import tools from 'tools'
import { useTranslation } from "react-i18next";
import ReusableButton from "components/Elements/ReusableButton";
import { CheckOutlined, CloseSquareOutlined, EditOutlined, ExportOutlined, FileSearchOutlined } from "@ant-design/icons";

import * as XLSX from 'xlsx';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { selectBranchList } from "utils/redux/actions/branchAction";
import EllipsisDropdown from "components/shared-components/EllipsisDropdown";

const { RangePicker } = DatePicker;

const FeedbackPage = (props) => {

    const { i18n, t } = useTranslation();
    const [feedbackData, setFeedbackData] = useState([]);
    const [selectedDates, setSelectedDates] = useState(null);
    const [searchterm, setSearchTerm] = useState();
    const [SelectedBranch, setSelectedBranch] = useState(0);
    const [selectedStatus, setSelectedStatus] = useState(0);
    const [selectedType, setSelectedType] = useState(0);

    const currentLang = i18n.language;

    const dateLocale = currentLang === "tr" ? localeTR : localeEN;
    const dateFormat = currentLang === "tr" ? 'DD.MM.YYYY' : 'MM/DD/YYYY';

    moment.locale(currentLang === 'tr' ? 'tr' : 'en-gb');

    const { branchList } = props;

    useEffect(() => {
        selectFeedbackData();

        var params = {}
        props.selectBranchListAction(params);
    }, []);

    const selectFeedbackData = async () => {
        var params = {}
        const result = await network.get("/admin/Feedback/GetAllFeedbackByClient", params, false);

        const { data } = result.data;

        setFeedbackData(data);
    }

    const filteredData = feedbackData.filter(item => {
        if (selectedDates || searchterm || selectedStatus || SelectedBranch || selectedType) {
            const itemDate = moment(item.feedbackDate);

            const isDateValid = selectedDates?.length === 2
                ? itemDate >= selectedDates[0]?.startOf('day') && itemDate <= selectedDates[1]?.endOf('day')
                : true;


            const normalizeText = (text) =>
                text.toLocaleLowerCase('tr').normalize('NFKC');

            const isSearch = searchterm
                ? Object.values(item).some(value =>
                    normalizeText(String(value)).includes(normalizeText(searchterm))
                )
                : true;

            const isBranchValid = SelectedBranch ? item.branchId === SelectedBranch : true;


            const isStatus = selectedStatus ? item.status == selectedStatus : true;

            const isType = selectedType ? item.type == selectedType : true;


            return isDateValid && isSearch && isBranchValid && isStatus && isType;
        } else {
            return feedbackData;
        }
    })


    // const handleExcelExport = () => {
    //     const excelData = filteredData.map((record) => ({
    //         [t("clientName")]: record.clientname,
    //         [t("clientNumber")]: record.clientnumber,
    //         [t("stampDate")]: new Date(record.stampdate).toLocaleDateString(),
    //         [t("stampStatus")]: record.status == 3 ? t("cancelled") :
    //             record.status == 1 ? t("pending") :
    //                 record.islaststamp ? t("gift") : t("approved"),
    //         [t("productCode")]: record.productcode,
    //         [t("productName")]: record.productname,
    //         [t("giftCode")]: record.giftcode,
    //         [t("branch")]: record.branchname,
    //     }));

    //     // Create a new worksheet and add the data
    //     const worksheet = XLSX.utils.json_to_sheet(excelData);
    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, "Stamps");

    //     // Export to Excel
    //     XLSX.writeFile(workbook, "StampData.xlsx");
    // };



    function checkProcessStatus(item) {
        if (item.status === 1) {
            return <Tag color="blue">{t("new")}</Tag>;
        } else if (item.status === 2) {
            return <Tag color="orange">{t("inProgress")}</Tag>;
        } else if (item.status === 3) {
            return <Tag color="green">{t("resolved")}</Tag>;
        }
        return null;
    }

    const updateStatus = async (newStatus, feedbackId) => {
        try {
            const params = { status: newStatus, feedbackId };
            const result = await network.post("/admin/Feedback/updateFeedbackStatus", params, false);

            if (result.isSuccess) {
                message.success(t("messages.statusUpdated"));
                selectFeedbackData();
            } else {
                message.error(t("messages.statusUpdateError"));
            }
        } catch (error) {
            // console.error("Durum değiştirme hatası:", error);
            message.error(t("messages.serverError"));
        }
    };

    const dropdownMenu = (record) => {
        const options = [
            { label: t("new"), key: "3", icon: <EditOutlined />, status: 1 },
            { label: t("inProgress"), key: "4", icon: <FileSearchOutlined />, status: 2 },
            { label: t("resolved"), key: "5", icon: <CheckOutlined />, status: 3 }
        ];

        return options
            .filter(option => option.status !== record.status) // Mevcut durumu hariç tut
            .map(option => ({
                label: <span>{option.label}</span>,
                key: option.key,
                icon: option.icon,
                onClick: () => updateStatus(option.status, record.feedbackId)
            }));
    };


    const tableColumn = [
        {
            title: t("clientName"),
            dataIndex: "clientName",
            align: "center",
            sorter: (a, b) => tools.antdTableSorter(a, b, "clientname"),
            render: (_, record) => (
                <div style={{ textAlign: "center" }}>{record.clientName}</div>
            ),
        },
        {
            title: t("date"),
            dataIndex: "feedbackDate",
            align: "center",
            sorter: (a, b) => tools.antdTableSorter(a, b, "feedbackDate"),
            render: (_, record) => (
                <div style={{ textAlign: "center" }}>
                    {moment(record.feedbackDate).format(
                        currentLang === "tr" ? "DD.MM.YYYY HH:mm" : "MM/DD/YYYY hh:mm A"
                    )}
                </div>
            ),
        },
        {
            title: t("suggestionComplaint"),
            dataIndex: "type",
            align: "center",
            sorter: (a, b) => tools.antdTableSorter(a, b, "feedbackDate"),
            render: (_, record) => (
                <div style={{ textAlign: "center" }}>
                    {record.type == 1 ? t("suggestion") : t("complaint")}
                </div>
            ),
        },
        {
            title: t("branch"),
            dataIndex: "branchName",
            align: "center",
            render: (_, record) => (
                <div style={{ textAlign: "center" }}>{record.branchName}</div>
            ),
        },
        {
            title: t("content"),
            dataIndex: "feedbackContent",
            align: "center",
            render: (_, record) => (
                <div className="markdown-container" style={{
                    backgroundColor: "#DCF8C6",
                    borderRadius: "12px",
                    padding: "10px 15px",
                    color: "#111111",
                    fontWeight: 400,
                    maxWidth: "75%",
                    wordWrap: "break-word",
                    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                    display: "inline-block",
                    margin: "5px 0",
                    alignSelf: "flex-end",
                }}>
                    {record.feedbackContent}
                </div>
            ),
        },
        {
            title: t("status"),
            dataIndex: "status",
            align: "center",
            render: (_, record) => (
                <div style={{ textAlign: "center" }}>
                    {checkProcessStatus(record)}
                </div>
            ),
        },
        {
            dataIndex: "",
            render: (_, record) => (
                <div>
                    <EllipsisDropdown menu={{ items: dropdownMenu(record) }} />
                </div>
            )
        }
    ];


    return (
        <>

            <Card title={t("suggestionComplaint")}>
                <div className="mb-1" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div className="mb-2" style={{ display: "flex", alignItems: "center", gap: "15px" }}>

                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <label style={{ marginLeft: "4px", marginBottom: "4px", fontWeight: "bold" }}>
                                {t("dateRange")}
                            </label>
                            <RangePicker
                                onChange={(dates) => setSelectedDates(dates)}
                                style={{ width: "100%", maxWidth: "300px" }}
                                format={dateFormat}
                                locale={dateLocale}
                                placeholder={[t("startDate"), t("endDate")]}
                            />
                        </div>

                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <label style={{ marginLeft: "4px", marginBottom: "4px", fontWeight: "bold" }}>
                                {t("status")}
                            </label>
                            <Select
                                options={[
                                    { value: 0, label: t("all") },
                                    { value: 1, label: t("new") },
                                    { value: 2, label: t("inProgress") },
                                    { value: 3, label: t("resolved") },
                                ]}
                                style={{ width: "200px" }}
                                onChange={(value) => setSelectedStatus(value)}
                                placeholder={t("select")}
                            />
                        </div>

                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <label style={{ marginLeft: "4px", marginBottom: "4px", fontWeight: "bold" }}>
                                {t("suggestionComplaint")}
                            </label>
                            <Select
                                options={[
                                    { value: 0, label: t("all") },
                                    { value: 1, label: t("suggestion") },
                                    { value: 2, label: t("complaint") },
                                ]}
                                style={{ width: "200px" }}
                                onChange={(value) => setSelectedType(value)}
                                placeholder={t("select")}
                            />
                        </div>

                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <label style={{ marginLeft: "4px", marginBottom: "4px", fontWeight: "bold" }}>
                                {t("branchSelection")}
                            </label>
                            <Select
                                style={{ width: "150px" }}
                                placeholder={t("selectBranch")}
                                options={[
                                    { value: 0, label: t("all") },
                                    ...branchList.map(item => ({
                                        value: item.branchid,
                                        label: item.branchname
                                    }))
                                ]}
                                onChange={(value) => setSelectedBranch(value)}
                            />
                        </div>

                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <label style={{ marginLeft: "4px", marginBottom: "4px", fontWeight: "bold" }}>
                                {t("search")}
                            </label>
                            <Input
                                placeholder={t("searchPlaceholder")}
                                value={searchterm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                style={{ width: "200px" }}
                            />
                        </div>
                    </div>

                    {/* <div>
            <ReusableButton
                variant={"template"}
                text={t("exportToExcel")}
                icon={<ExportOutlined />}
                onClick={() => handleExcelExport()}
            />
        </div> */}
                </div>

                <Table
                    key={feedbackData.length}
                    columns={tableColumn}
                    dataSource={[...filteredData].reverse()}
                    pagination={{
                        total: filteredData.length,
                        showTotal: (total) => `${t("total")}: ${total}`
                    }}
                />
            </Card>


        </>
    )
}

function mapStateToProps(state) {

    return {
        branchList: state.branchReducer.branchList
    }
}

function mapDispatchToProps(dispatch) {
    return {
        selectBranchListAction: bindActionCreators(selectBranchList, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackPage);
